import { Component, OnInit } from '@angular/core';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { AccountService } from 'src/app/services/account.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AccountResponse } from 'src/app/models/account.model';
import { BankTransferRegister } from 'src/app/models/bank.model';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { VendorResponse } from 'src/app/models/vendor.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyService } from 'src/app/services/company.service';
import { UserSaved } from 'src/app/models/user.model';
declare let $: any;

@Component({
  selector: 'app-banking',
  templateUrl: './banking.component.html',
  styleUrls: ['./banking.component.scss']
})
export class BankingComponent implements OnInit {
  inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
  allCompanies: CompanyRoleResponse[] = [];
  companies: CompanyRoleResponse[] = [];
  selected: CompanyRoleResponse = null;
  timeout = null;
  banks: AccountResponse[] = null;
  banksForClients: AccountResponse[] = null;
  accountSelected = null;
  registers: BankTransferRegister[] = [];
  cashiers = [];
  upload = new ButtonLoading("btn-success", false, "CARGAR", "fa-upload");
  user: UserSaved = null;

  constructor(
    private authService: AuthenticationService,
    private accountService: AccountService,
    private toastService: ToastrService,
    private saleService: InvoiceSaleService,
    private companyService: CompanyService
  ) {
    this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
    this.user = this.authService.getUser();
    this.allCompanies = this.companies;
  }

  ngOnInit(): void {
      if (this.user.contadorGT) {
        this.getAssociatedCompanies();
      }
  }
  
  getAssociatedCompanies() {
    this.companyService.getCompaniesAssociatedToPartner(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }

  searchCompany() {
    clearTimeout(this.timeout);
    this.inputs.class = "typing";
    this.timeout = setTimeout(() => {
      this.companies = this.allCompanies.filter((company) => {
        var val = this.inputs.value.toLowerCase();
        return company.alphanumericId.toLowerCase() == val || company.companyName.toLowerCase().includes(val) || company.companyNIT.toLowerCase().includes(val);
      });
      this.inputs.verified = false;
      if (this.companies.length > 0) {
        this.inputs.class = "fa-list";
      } else {
        this.inputs.class = "fa-xmark";
      }
    }, 300);
  }

  removeBank() {
    this.banksForClients = this.banks.filter((bank) => {
      return bank.id != this.accountSelected
    });
  }

  selectCompany(selected: any) {
    this.inputs.value = selected.alphanumericId + " - " + (selected.companyNIT ? selected.companyNIT : selected.nit) + " - " + (selected.companyName ? selected.companyName : selected.name);
    this.inputs.verified = true;
    this.inputs.class = "fa-circle-check";
    this.selected = selected;
    this.accountService.getAccountsCompany(selected.companyId ? selected.companyId : selected.id).subscribe({
      next: (response: ResponseObject) => {
        this.accountSelected = undefined;
        this.banks = response.data as AccountResponse[];
        this.banksForClients = this.banks;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
    this.accountService.getCashBanks(selected.companyId ? selected.companyId : selected.id).subscribe({
      next: (response: ResponseObject) => {
        this.cashiers = response.data as AccountResponse[];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const file: File = target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent) => {
        const csvData = e.target['result'] as string;
        this.processData(csvData);
      };
      reader.readAsText(file);
    }
  }

  processData(csvData: string) {
    const rows = csvData.split(/\r?\n/);
    for (const row of rows) {
      const clean_row = this.replaceNumbersWithCommas(row);
      const columns = clean_row.split(/[,;]/);
      var newBankRegister = new BankTransferRegister();
      newBankRegister.date = columns[0];
      newBankRegister.reference = columns[1];
      newBankRegister.debit = columns[2];
      newBankRegister.credit = columns[3];
      newBankRegister.balance = columns[4];
      newBankRegister.description = columns[5];
      newBankRegister.operation = 1;
      newBankRegister['input'] = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
      if (columns[0]) {
        this.registers.push(newBankRegister);
      }
    }
    for (const register of this.registers) {
      this.selectInitsValue(register);
    }
  }

  replaceNumbersWithCommas(texto) {
    // Esta expresión regular busca números con comas y puntos decimales
    const regex = /(\d{1,3}(?:,\d{3})*(\.\d+)?)/g;

    // Reemplazamos cada coincidencia en el texto
    return texto.replace(regex, (match) => {
      // Eliminamos las comas de los números
      return match.replace(/,/g, '');
    });
  }

  writeClient(register) {
    var isClient = true;
    var input = register['input'] as InputAutocompleteModel;
    if (register.operation == 4 || register.operation == 6 || register.operation == 9) {
      isClient = false;
    }
    input.verified = false;
    this.saleService.getClientsOrProvidersForBank(input.value, this.selected.companyId, isClient).subscribe({
      next: (response: ResponseObject) => {
        input.filterElements = response.data;
        if (response.data.length > 0) {
          input.class = "fa-list";
        } else {
          input.class = "fa-xmark";
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  selectClient(client: VendorResponse, register: BankTransferRegister) {
    var input = register['input'] as InputAutocompleteModel;
    input.value = client.name;
    input.verified = true;
    input.class = "fa-circle-check";
    register.client = client.id + "";
  }

  reset(register) {
    var input = register['input'] as InputAutocompleteModel;
    input.value = "";
    input.verified = false;
    input.class = "fa-asterisk";
    input.filterElements = [];
    register.client = undefined;

    if (Number(register.operation) === 7) {
      register.client = 20;
    }

    this.selectInitsValue(register);
  }

  uploadRegisters() {
    if (this.upload.loading) {
      return;
    }
    this.upload.loading = true;
    this.accountService.saveRegisters(this.selected.companyId, this.accountSelected, this.registers).subscribe({
      next: (response: ResponseObject) => {
        this.upload.loading = false;
        this.toastService.success("Exito!");
        this.resetPage();
      },
      error: (error: HttpErrorResponse) => {
        this.upload.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }
  
  resetPage() {
    this.registers = [];
    this.accountSelected = null;
    this.banks = null;
    this.banksForClients = null;
    this.cashiers = [];
    this.upload = new ButtonLoading("btn-success", false, "CARGAR", "fa-upload");
    this.inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
    this.selected = null;
  
    if (this.user.contadorGT) {
      this.getAssociatedCompanies();
    }
  
    const fileInput = document.getElementById('file') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  selectInitsValue(register){
    if ((register.operation === 1 || register.operation === "1" ) && this.banksForClients.length === 1) {
      register.client = this.banksForClients[0].id;
    }
  
    if ((register.operation === 2 || register.operation === "2") && this.cashiers.length === 1) {
      register.client = this.cashiers[0].id;
    }

    if ((register.operation === 7 || register.operation === "7")) {
      register.client = 20;
    }
  }
  
}
